import { useEffect } from 'react'
import { Users } from '../services/user'
import { useUserStore } from '../store'

const getCookie = (name: string): string | null => {
	const value = `; ${document.cookie}`
	const parts = value.split(`; ${name}=`)
	if (parts.length === 2) return parts.pop()?.split(';').shift() || null
	return null
}

export const useAffiliateTracking = () => {
	const user = useUserStore((state) => state.user)

	useEffect(() => {
		const updateAffiliateInfo = async () => {
			if (!user || !user.email_verified) {
				return
			}

			if (user?.referly_referral_profile?.referral_id) {
				return
			}

			const programIdElement = document.querySelector('script[data-affiliate]')
			const programId = programIdElement?.getAttribute('data-program-id')

			if (!programId) {
				return
			}

			// Referly cookie name: ${PROGRAM_ID}_affiliate_ref
			const cookieName = `${programId}_affiliate_ref`
			const affiliateToken = getCookie(cookieName)

			if (!affiliateToken) {
				return
			}

			await updateReferralInfo(affiliateToken)
		}

		const updateReferralInfo = async (affiliateToken: string) => {
			await Users.updateReferral({
				token: affiliateToken
			})
		}

		updateAffiliateInfo()
	}, [user])
}
